import Badge from './Badge';

export default {
  id: 'radial_10',
  title: 'Radial_10',
  colors: 2,
  premium: true,
  BadgeComponentStateless: Badge
};
